$(document).ready(function () {
    $("#formContact_modal .button-check-all").on("click", function () {

        $('#formContactAgreeEmail').prop("checked", true);
        $('#formContactAgreePhone').prop("checked", true);
        $('#formContactAgreeRegulations1').prop("checked", true);
        $('#formContactAgreeRegulations2').prop("checked", true);
    });

    function submitContactForm(e, number = '') {
        {
            console.log('op');
            e.preventDefault();
            $('.is-invalid').removeClass('is-invalid');
            $('.invalid-feedback').empty();

            var firstname = $('#formMarketFirstname' + number).val();
            var errors = 0;
            $('.form-group--register-firstname').siblings('invalid-feedback').prevObject.empty();
            if (!firstname) {
                $('#formMarketFirstname' + number).addClass('is-invalid');
                var errors = 1;
                $('.formMarketFirstname' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
            } else {
                if (firstname.length < 3) {
                    $('#formMarketFirstname' + number).addClass('is-invalid');
                    var errors = 1;
                    $('.formMarketFirstname' + number).siblings('invalid-feedback').prevObject.html('<p>Imię musi zawierać minimum trzy litery.</p>');
                } else {
                    $('#formMarketFirstname' + number).removeClass('is-invalid');
                }
            }

            var lastname = $('#formMarketLastname' + number).val();
            $('.form-group--register-lastname').siblings('invalid-feedback').prevObject.empty();
            if (!lastname) {
                $('#formMarketLastname' + number).addClass('is-invalid');
                var errors = 1;
                $('.formMarketLastname' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
            } else {
                if (lastname.length < 3) {
                    $('#formMarketLastname' + number).addClass('is-invalid');
                    var errors = 1;
                    $('.formMarketLastname' + number).siblings('invalid-feedback').prevObject.html('<p>Nazwisko musi zawierać minimum trzy litery.</p>');
                } else {
                    $('#formMarketLastname' + number).removeClass('is-invalid');
                }
            }


            var email = $('#formMarketEmail' + number).val();
            if (!email) {
                $('#formMarketEmail' + number).addClass('is-invalid');
                $('.formMarketEmail' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
                var errors = 1;
            } else {
                if (email) {
                    $('#formMarketEmail' + number).removeClass('is-invalid');
                } else {
                    $('#formMarketEmail' + number).addClass('is-invalid');
                    $('.formMarketEmail' + number).siblings('invalid-feedback').prevObject.html('<p>Wpisz poprawny adres e-mail</p>');
                    var errors = 1;
                }
            }

            var phoneInput = $('#formMarketPhone' + number);

            var phone = phoneInput.val();
            if (!phone) {
                $('#formMarketPhone' + number).addClass('is-invalid');
                $('.formMarketPhone' + number).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
                var errors = 1;
            } else {
                if (phone) {
                    if (phone.length < 7) {
                        $('#formMarketPhone' + number).addClass('is-invalid');
                        $('.formMarketPhone' + number).siblings('invalid-feedback').prevObject.html('<p>Podany numer telefonu jest za krótki</p>');
                        var errors = 1;
                    } else {
                        if (!validatePhone(phone)) {
                            $('#formMarketPhone' + number).addClass('is-invalid');
                            $('.formMarketPhone' + number).siblings('invalid-feedback').prevObject.html('<p>Wpisz poprawny 9-cyfrowy numer telefonu</p>');
                            var errors = 1;
                        } else {
                            $('#formMarketPhone' + number).removeClass('is-invalid');
                        }
                    }
                }
            }

            var selectedDealer = $("#inputDealer" + number).val();
            if (selectedDealer === null) {
                $('#inputDealer' + number).addClass('is-invalid');
                $('.inputDealer' + number).html('<p>Proszę wybrać dealera</p>').show();
                var errors = 1;
            } else {
                $('.inputDealer' + number).removeClass('is-invalid');
            }

            let inputDealer = $(`#inputDealer`);
            var dealerAutobahnId = 0;
            for (const findElement of inputDealer.find("option")) {
                if ($(findElement).text().toLowerCase() === salesman.toLowerCase()) {
                    dealerAutobahnId = $($(findElement)[0]).attr('data-id');
                    console.log(dealerAutobahnId);
                    break;
                }
            }
            console.log(dealerAutobahnId);

            var modelId = $("#inputModel" + number).val();
            if (modelId === null) {
                $('#inputModel' + number).addClass('is-invalid');
                $('.inputModel').html('<p>Proszę wybrać model</p>').show();
                var errors = 1;
            } else {
                $('#inputModel' + number).removeClass('is-invalid');
            }

            var salesmanName = $("#inputSalesman").val();
            if (salesmanName === null) {
                $('#inputSalesman').addClass('is-invalid');
                $('.inputSalesman').html('<p>Proszę wybrać handlowca</p>').show();
                var errors = 1;
            } else {
                $('#inputSalesman').removeClass('is-invalid');
            }


            var dealer = $('#input_dealer').val();
            var message = $('#formMarketQuestion' + number).val();
            var agree1 = $('#formMarketAgreeEmail' + number).prop('checked');
            var agree2 = $('#formMarketAgreePhone' + number).prop('checked');
            var agree3 = $('#formMarketAgreeRegulations1' + number).prop('checked');
            var agree4 = $('#formMarketAgreeRegulations2' + number).prop('checked');
            var agreeVal1 = 0;
            var agreeVal2 = 0;
            var agreeVal3 = 0;
            var agreeVal4 = 0;
            if (agree1) {
                agreeVal1 = 1;
            }
            if (agree2) {
                agreeVal2 = 1;
            }
            if (agree3) {
                agreeVal3 = 1;
            }
            if (agree4) {
                agreeVal4 = 1;
            }

            if (!agree1 && !agree2 && !agree3) {
                var errors = 1;
                $('.form-check-input#formMarketAgreeEmail' + number).addClass('is-invalid');
                $('.formMarketAgreeEmail').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
                $('.form-check-input#formMarketAgreePhone' + number).addClass('is-invalid');
                $('.formMarketAgreePhone').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
                $('.form-check-input#formMarketAgreeRegulations1' + number).addClass('is-invalid');
                $('.formMarketAgreeRegulations1').html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            }

            if (!email && !phone) {
                var errors = 1;
                $('#formMarketEmail' + number).addClass('is-invalid');
                $('.form-group--register-email .invalid-feedback').html('<p>Proszę podać dane na co najmniej jeden kanał komunikacji</p>').show();
                $('#formMarketPhone' + number).addClass('is-invalid');
                $('.form-group--register-phone .invalid-feedback').html('<p>Proszę podać dane na co najmniej jeden kanał komunikacji</p>').show();
            }

            var emailCheckbox = $('#formMarketEmail' + number);
            var agree1 = $('#formMarketAgreeEmail' + number);

            if (agree1.is(':checked')) {
                if (emailCheckbox.val() === '') {
                    var errors = 1;
                    $('.invalid-feedback-agree-email').html('<p> Nie podałes E-maila </p>').show();
                }
            }


            var phoneCheckbox = $('#formMarketPhone' + number);
            var agree2 = $('#formMarketAgreePhone' + number);

            if (agree2.is(':checked')) {
                if (phoneCheckbox.val() === '') {
                    var errors = 1;
                    $('.invalid-feedback-agree-phone').html('<p> Nie podałes numeru telefonu </p>').show();
                }
            }


            var agree3 = $('#formMarketAgreeRegulations1' + number).prop('checked');
            /*if (!agree3) {
                $('#formMarketAgreeRegulations1' + number).addClass('is-invalid');
                $('.invalid-feedback-agree-regulations1').html('<p>To pole jest wymagane</p>').show();
                var errors = 1;
            } else {
                $('#formMarketAgreeRegulations1' + number).removeClass('is-invalid');
                $('.invalid-feedback-agree-regulations1').empty().hide();
                agree3 = 1;
            }*/

            var agree4 = $('#formMarketAgreeRegulations2' + number).prop('checked');
            if (!agree4) {
                $('#formMarketAgreeRegulations2' + number).addClass('is-invalid');
                $('.invalid-feedback-agree-regulations2').html('<p>To pole jest wymagane</p>').show();
                var errors = 1;
            } else {
                $('#formMarketAgreeRegulations2' + number).removeClass('is-invalid');
                $('.invalid-feedback-agree-regulations2').empty().hide();
                agree4 = 1;
            }


            console.log(errors);
            if (errors == 0) {
                $('#contact_submit_btn').attr("disabled", "true");

                let formType = "ask_offer";

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'formSubmit',
                    form_id: formType,
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    phone: phone,
                    message: message,
                    comment: message,
                    model_id: modelId ?? "",
                    branch_id: dealerAutobahnId ?? "",
                    salesman_name: salesmanName ?? "",
                    /*utm_source: utm_source,
                    utm_medium: utm_medium,
                    utm_campaign: utm_campaign,*/
                    agree_regulations1: agreeVal1,
                    agree_regulations2: agreeVal2,
                    agree_regulations3: agreeVal3,
                    agree_regulations4: agreeVal4,
                    source: "iframe_targi",
                    book_type: formType
                });

                $.ajax({
                    type: 'POST',
                    url: '/pms2025',
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        firstname: firstname,
                        lastname: lastname,
                        email: email,
                        phone: phone,
                        message: message,
                        comment: message,
                        branch_id: dealerAutobahnId,
                        model_id: modelId,
                        salesman_name: salesmanName ?? "",
                        /*utm_source: utm_source,
                        utm_medium: utm_medium,
                        utm_campaign: utm_campaign,*/
                        contact_channel_email: (agreeVal1 ? 1 : 0),
                        contact_channel_sms: (agreeVal2 ? 1 : 0),
                        contact_channel_phone: (agreeVal3 ? 1 : 0),
                        i_consent_to_the_processing_of_my_data: (agreeVal4 ? 1 : 0),
                        source: "iframe_targi",
                        event_id: 50,
                        book_type: formType,
                        type: formType
                    },
                    success: function (result) {

                        console.log(result.success);
                        $('#contact_submit_btn').removeAttr("disabled");
                        if (result.success) {


                            $('#formSuccess').modal('show')
                            $("#formMarket_modal" + number).trigger("reset");
                            $('#inputModel' + number).val('');
                            $("#select2-inputModel-container").html("Wybierz model");
                            $('#inputDealer' + number).val('');
                            $("#select2-inputDealer-container").html("Wybierz dealera");
                            $('#inputSalesman' + number).val('');
                            $("#select2-inputSalesman-container").html("Wybierz handlowca");
                            $('#formMarketFirstname' + number).val('');
                            $('#formMarketLastname' + number).val('');
                            $('#formMarketEmail' + number).val('');
                            $('#formMarketPhone' + number).val('');
                            $('#formMarketQuestion' + number).val('');
                            $('#formMarketAgreeEmail' + number).prop('checked', false);
                            $('#formMarketAgreePhone' + number).prop('checked', false);
                            $('#formMarketAgreeRegulations1' + number).prop('checked', false);
                            $('#formMarketAgreeRegulations2' + number).prop('checked', false);
                            //window.location.reload();

                            // $('#exampleModalCenter2').modal({
                            //     keyboard: false,
                            //     backdrop: 'static',
                            // });
                            // $('#exampleModalCenter2').modal('show')
                            // $("#formMarket_main").trigger("reset");


                        } else {
                            alert('Zapis nie powiódł się. Spróbuj ponownie');
                        }
                    }
                });
            }
        }
    }

    $("#formMarket").submit((e) => submitContactForm(e));
    $('#formContactQuestion').on('input', function () {
        currentLength = $(this).val().length;
        const remaining = 300 - currentLength;
        $('#formContactQuestionHelp').text(`Wykorzystano ${currentLength}/300 znaków`);
    });

    let salesman = 'Wybierz handlowca';
    let intervals = setInterval(updateSalesman, 1000);

    /**
     number: 0 = kontakt,
     1 = drugi kontakt na stronie modelu,
     2 = jazda testowa
     */
    function updateSalesman() {
        let input = $(`#select2-inputDealer-container`);
        let inputDealer = $(`#inputDealer`);
        let id = 0;

        /*let salesmans = {
            257: ["Masłowski Krzysztof", "Lewkowicz Jaroslaw", "Kamont Eryk", "Wojsławowicz Adrian", "Puzio Olga"],
            341: ["Kuncikowska Aneta","Dyrdek Andrzej","Przybulska Agnieszka","Michalczyk Wojciech","Sołdra Aleksandra","Krogulski Filip","Piątek Wojciech","Kwaśniak Sławomir"],
            272: ["Biesalski Jakub","Bialowas Grzegorz","Umiński Karol","Masłowski Krzysztof","Lewkowicz Jaroslaw","Kamont Eryk","Wojsławowicz Adrian"],
            256: ["Itrich Paweł","Lidke Sławomir","Walczykiewicz Maciej"],
            342: ["Kubik Michał","Górski Aleksander","Jesionek Weronika",                "Szyszka Katarzyna",
                "Kałus Marcin",                "Dziacko Artur",                "Daniel Ewa",              "Gryń Damian",
                "Urban Aleksandra"],
            255: ["Sadkowski Filip",
                "Miński Mariusz",
                "Kulicz Żaneta",
                "Raczkowski Mariusz",
                "Czernuszewicz Marcin",
                "Czerkawski Wojciech",
                "Borus Piotr",
                "Dusińska Patrycja",
                "Tylski Marcin",
                "Koch Beniamin",
                "Kaczorowska Marta"],
            292: ["Płonka Grzegorz",
                "Drzażdżewski Bartłomiej",
                "Lauer Sławomir",
                "Szymann Mateusz",
                "Matuszek Krzysztof",
                "Mirowski Dominik"],
            265: ["Kowalczyk BARTOSZ",
                "Kaczmarski Pawel",
                "Krasoń Tomasz",
                "BIELECKI MACIEJ",
                "Pająk Nina",
                "Bełtowski Daniel",
                "Niebudkowski Jakub",
                "Bróż Marek",
                "Huk Karolina",
                "Kopycki Adrian",
                "Urlich Kordian",
                "Mordel Anna",
                "AUGUSTYŃSKI RAFAŁ",
                "ŁADNY PATRYK",
                "Michałkiewicz-Bis Monika",
                "Karyś Marcin",
                "Fornal Paulina",
                "Nędzyński Michał",
                "MICHAŁKIEWICZ-BIS MONIKA",
                "Gregorczyk Klaudia",
                "Puziewicz Mateusz"],
            308: ["Kołodziejczak Łukasz",
                "Borowski Andrzej",
                "GĄSIENICA-MIKOŁAJCZYK SZYMON",
                "Wąsik Tomasz",
            "Koszuda Damian"],
            253: ["Dębowska Magdalena",
                "Witan Krzysztof",
                "Kamiński Jakub",
                "Bałucka Natalia",
                "Czyż Bartłomiej",
                "Zaboub Kamil",
                "Kobiałka Sławomir",
                "Czarnecki Kacper",
                "Tomaszewska Agnieszka",
                "Socha Mateusz"],
            254: ["Płaziuk Jarosław",
                "Warchol Jerzy",
                "Grzesiak Piotr",
                "Chomiuk Marek",
                "Katanowska Marzena",
                "WARCHOŁ ANNA",
                "KALEMBA PAWEŁ",
                "JURYCZ MILENA",
                "Pawlak Jakub"],
            299: ["Jankowiak Arkadiusz",
                "Damrych Sławomir"],
            250: ["Pulnar Pawel",
                "Helwing Krzysztof",
                "Sułek Dariusz",
                "Radecka Zaneta",
                "Sułek Dariusz",
                "Kaczmarska Magdalena",
                "Żurak Radosław",
                "Stanisławski Roman",
                "Klimczak Martyna"],
            266: ["Misiak Paweł",
                "Maciejewska Magdalena",
                "Polody Piotr",
                "Ganda Patryk",
                "Daraszkiewicz Igor",
                "Jasiński Tomasz"],
            309: ["Dadacz Daniel",
                "Stasiak Przemysław",
                "Śledziewski Kamil",
                "Morawski Rafał",
                "Braumberger Adam",
                "Kowalewska Jennifer"],
            259: ["Runowski Lukasz",
                "Bajda Michal",
                "Michalik Patrycja",
                "Mazurek Monika",
                "Barwiński Szymon",
                "Smyl Arkadiusz"],
            310: ["Tomaszek Paweł",
                "Władziński Grzegorz",
                "Ruciński Piotr"],
            252: ["Zimnicki Przemyslaw",
                "Rospędowska Agnieszka",
                "Kucharek Dariusz",
                "Zasadni Klaudia",
                "Czub Rafal"],
        }*/

        if (input.length > 0) {
            if (salesman !== input.attr('title')) {
                salesman = input.attr('title');
                for (const findElement of inputDealer.find("option")) {
                    if ($(findElement).text().toLowerCase() === salesman.toLowerCase()) {
                        id = $(findElement)[0].value;
                        break;
                    }
                }

                /*let dealerInput = $("#inputSalesman");
                dealerInput.find('option').remove();
                dealerInput.append(`<option value="">Wybierz handlowca</option>`)
                for (const dealer of salesmans[id])
                    dealerInput.append(`<option value="${dealer}">${dealer}</option>`);*/

                $.ajax({
                    _token: $('#token').val(),
                    url: '/filter_salesman',
                    type: 'GET',
                    data: {salesman_id: id},
                }).then(function (dealers) {
                    let dealerInput = $("#inputSalesman");
                    dealerInput.find('option').remove();
                    dealerInput.append(`<option value="">Wybierz handlowca</option>`)
                    for (const dealer of dealers)
                        dealerInput.append(`<option value="${dealer.value}">${dealer.name}</option>`);
                })
            }
        }
    }

    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function validatePhone(txtPhone) {
        var regex = /^[0-9]+$/
        return regex.test(txtPhone);
    }

    function mobileCheck() {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v\|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substring(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    function getLocation(position) {
        let location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        };
        $.ajax({
            _token: $('#token').val(),
            url: '/get_dealers',
            type: 'GET',
        }).then(function (dealers) {
            let nearest = findNearestDealer(location, dealers);
            $(".inputProvinceWrapper").css('display', 'none');
            let dealerInput = $("#inputDealer");
            dealerInput.find('option').remove();
            dealerInput.append(`<option value="${nearest.department_autobahn_company_id}" selected>${nearest.department_city} ${nearest.department_name} (wg lokalizacji)</option>`);
        })
    }

    function findNearestDealer(searchLocation, dealerMarkersArray) {
        if (!searchLocation || !dealerMarkersArray || dealerMarkersArray.length === 0) {
            return null;
        }

        function haversine(lat1, lon1, lat2, lon2) {
            const R = 6371;
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c; //distance
        }

        let nearestDealer = null;
        let minDistance = Number.MAX_VALUE;

        dealerMarkersArray.forEach(dealer => {
            const distance = haversine(
                searchLocation.lat,
                searchLocation.lng,
                dealer.department_latitude,
                dealer.department_longitude
            );
            if (distance < minDistance) {
                minDistance = distance;
                nearestDealer = dealer;
            }
        });
        return nearestDealer;
    }
});
